/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useSelector } from 'react-redux';
// We actually return an annotated, typed version of use selector here
export const useRootSelector = useSelector;